import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import CommunityDetailPage from './CommunityDetailPage';

function CommunityDetail({ community, homes, plans }) {
  return (
    <PageWrapper>
      <PageHelmet community={community} />
      <CommunityDetailPage
        community={community}
        homes={homes}
        plans={plans}
      />
    </PageWrapper>
  );
}

CommunityDetail.propTypes = {
  community: PropTypes.object.isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    community: true,
    plans: true,
    homes: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/index.js